import { useCallback, useEffect, useRef, useState } from "react";

export function useDebounceFc(func: (...args: any) => void, time: number) {
  const callbackRef = useRef<typeof func | null>(null);
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    callbackRef.current = func;
  }, [func]);
  const run = useCallback(
    (args: any) => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        if (callbackRef.current) {
          callbackRef.current(args);
        }
      }, time);
    },
    [time],
  );
  return run;
}

export function useDebounce<T = unknown>(value: T, interval: number = 300) {
  const [debounced, setDebounced] = useState<T>(value);
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setDebounced(value);
      timerRef.current = null;
    }, interval);
  }, [value, interval]);
  return debounced;
}
